/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RevokeLiteLLMInstanceSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type RevokeLiteLLMInstanceRequest = {
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type RevokeLiteLLMInstanceSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RevokeLiteLLMInstanceSecurity$outboundSchema: z.ZodMiniType<
  RevokeLiteLLMInstanceSecurity$Outbound,
  RevokeLiteLLMInstanceSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function revokeLiteLLMInstanceSecurityToJSON(
  revokeLiteLLMInstanceSecurity: RevokeLiteLLMInstanceSecurity,
): string {
  return JSON.stringify(
    RevokeLiteLLMInstanceSecurity$outboundSchema.parse(
      revokeLiteLLMInstanceSecurity,
    ),
  );
}

/** @internal */
export type RevokeLiteLLMInstanceRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const RevokeLiteLLMInstanceRequest$outboundSchema: z.ZodMiniType<
  RevokeLiteLLMInstanceRequest$Outbound,
  RevokeLiteLLMInstanceRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function revokeLiteLLMInstanceRequestToJSON(
  revokeLiteLLMInstanceRequest: RevokeLiteLLMInstanceRequest,
): string {
  return JSON.stringify(
    RevokeLiteLLMInstanceRequest$outboundSchema.parse(
      revokeLiteLLMInstanceRequest,
    ),
  );
}
